module.exports = __webpack_public_path__ + "static/media/Shox 03.18ef1cb3.png";